<mat-nav-list>
    <a mat-list-item (click)="selecionaRelatorio('PDF')">
        <span mat-line>PDF</span>
    </a>

    <a mat-list-item (click)="selecionaRelatorio('DOCX')">
        <span mat-line>Word</span>
    </a>
</mat-nav-list>